module.exports = __webpack_public_path__ + "img/6.6e47bd7a.jpg";